<form [formGroup]="claimForm" (submit)="onSubmit()">
  <mat-form-field fxFlex>
    <mat-label>{{ 'dialog.charges.model-claim-search' | translate }}</mat-label>
    <input
      matInput
      formControlName="search"
      [placeholder]="'dialog.charges.model-claim-search-placeholder' | translate"
    >
    <mat-spinner *ngIf="loading$ | async; else showSubmit" matSuffix color="primary" [diameter]="24" class="mr-3"></mat-spinner>
    <ng-template #showSubmit>
      <button type="submit" matSuffix mat-icon-button>
        <mat-icon>search</mat-icon>
      </button>
    </ng-template>
    <mat-hint>{{ 'dialog.charges.model-claim-search-hint' | translate }}</mat-hint>
    <mat-error *ngIf="errorMessages$ | async as error"> {{ error }}</mat-error>
  </mat-form-field>
</form>
